import { gql } from '@apollo/client'

export const GOAL_GROUP_CHART = gql`
  query goalGroupChart(
    $goalGroupId: Int!
    $type: GoalGroupChartType!
    $funderOrgId: Int!
  ) {
    goalGroupChart(
      goalGroupId: $goalGroupId
      type: $type
      funderOrgId: $funderOrgId
    ) {
      id
      title
      target
      unitOfMeasurement
      goalId
      seriesData {
        goalName
        nonprofitOrgName
        data {
          x
          y
        }
      }
      totalValue
    }
  }
`
